import {Component} from '@angular/core';
import {Router} from "@angular/router";
import {TowerService} from "./api/service/tower.service";
import {NavigationService} from "./shared/navigation.service";
import {isNullOrUndefined} from "util";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  constructor(private router: Router,
              private towerService: TowerService,
              private navigationService: NavigationService) { }

  allowedLogs(): boolean{
    const token = this.navigationService.getToken();
    if(!isNullOrUndefined(token)){
      for (let feature of token.features){
        if(feature === 'logs'){
          return true;
        }
      }
    }
    return false;
  }

  allowedQueues(): boolean{
    const token = this.navigationService.getToken();
    if(!isNullOrUndefined(token)){
      for (let feature of token.features){
        if(feature === 'queues'){
          return true;
        }
      }
    }
    return false;
  }

  debranchements() {
    const token = this.navigationService.getToken();
    if(!isNullOrUndefined(token)){
      return token.debranchements;
    }
    return [];
  }

  actionDebranchement(id: number){
    this.towerService.getDebranchementUrl(id).subscribe(
      response => {
        window.open(response.url,'_blank');

      }, error => {
        alert('Erreur durant le debranchement');
      }
    );
  }

  actionQueues(){
    this.router.navigate(['/queues']);
  }

  actionLogs(){
    this.router.navigate(['/logs']);
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts